import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';
import { cssVar } from 'styles/helper';

export const MenuWithDropdownsContainer = styled(Stack)`
  border: 1px solid ${cssVar('border-primary')};
  box-shadow: ${cssVar('shadow-xs-skeuomorphic')};

  .dropdown-with-action {
    border-top: none;
    border-bottom: none;
  }
`;

// This avoids a visual glitch where the border looks duplicated / overlapped
export const DropdownStack = styled(Stack)`
  &:first-child {
    .dropdown-with-action {
      border-left: none;
    }
  }

  &:last-child {
    .dropdown-with-action {
      border-right: none;
    }
  }
`;
